import GerepAPI from './GerepAPI'

export const getMatrix = (token) => {
	return GerepAPI.get('/simulateur/matrix', null, token)
}

export const simulate = (token, values) => {
	return GerepAPI.post('/simulateur/simulate', values, token)
}
